import { runDemo } from "../shared/demoRunner";
import { createCustomRenderTargetScene } from "./scene";

runDemo({ createScene: createCustomRenderTargetScene });
